<template>
  <div class="login_form" @keydown="keydown">
    <!-- <div class=""><span>登录</span></div> -->
    <header><span>{{ t('login.title') }}</span><a-icon type="close" @click.stop="$FN.visibleLogin()" /></header>
    <AntGridSkeleton height="2.5rem" :num="4" :rows="4" :gap="2" :loading="skeletonLoading">
      <AntForm :data="form" :rows="1" layout="vertical" ref="AntForm" :key="key" />
      <div class="error_tips" v-show="errorTips">{{errorTips}}</div>
      <a-button class="ant_btn_login" block type="primary" @click="getToken" :loading="loading">{{ t('login.title') }}</a-button>
    </AntGridSkeleton>
    <div class="other"><span @click="forget">{{ t('login.forgetPassword') }}</span> | <span @click="$FN.visibleLogin(3)">{{ t('login.registerNow') }}</span></div>
  </div>
</template>

<script>
import { t } from '@/locales';
export default {
  data() {
    return {
      key: 0,
      errorTips: null,
      opacity: 0.5,
      recordsForm: {
        username: null,
        password: null,
        code: null,
      },
      skeletonLoading: true,
      form: {},
      loading: false,
      code: null,
      uuid: null,
      codeLoading: true,
      time: null
    }
  },
  created() {
    this.getCodeImg();
  },
  beforeDestroy() {
    this.clearTimeout();
  },
  watch: {
    '$store.state.language'() {
      if (this.code && this.uuid) this.setForm();
    }
  },
  methods: {
    t,
    clearTimeout() {
      clearTimeout(this.time);
      this.time = null;
    },
    records() {
      this.opacity = Object.values(this.recordsForm).every(a => a) ? 1 : 0.5;
    },
    change(data) {
      this.recordsForm = { ...this.recordsForm, ...data };
      this.records();
    },
    // 用户敲击回车
    keydown(e) {
      // 与表单change发生冲突，将任务放到宏任务中
      if (e.keyCode === 13) this.time = setTimeout(this.getToken, 250);
    },
    // 忘记密码
    forget() {
      this.$FN.visibleLogin();
      this.$router.$push("/forget");
    },
    // 获取用户token
    getToken() {
      this.clearTimeout();
      this.errorTips = null;
      this.$refs.AntForm.validateFields((error, form) => {
        if (!error) {
          let data = {
            uuid: this.uuid,
            source: "PES",
            password: this.$FN.setJSEncrypt(form.password),
          };
          let config = { contentType: "0" };
          this.loading = true;
          this.$FN.post("open/auth/login", { ...form, ...data }, config).then(res => {
            this.loading = false;
            if (res) {
              let { code = 500, data = {}, msg = null } = res;
              if (code === 100) {
                // 需用通过这个token去获取一个新token
                let token = data.user.user.roles[0].token;
                let user = data.user;
                user.token = token;
                user.newToken = data.token;
                // token获取成功之后获取用户权限
                this.$FN.login({ token, user }).then(success => {
                  if (success) {
                    this.$FN.visibleLogin();
                    this.$FN.getRoles({ token, user });
                    this.$router.$push("/home");
                  } else {
                    this.getCodeImg();
                  }
                });
              } else {
                this.errorTips = msg;
                this.getCodeImg();
              }
            } else {
              this.getCodeImg();
            };
          })
        }
      });
    },
    // 获取验证码图片
    getCodeImg() {
      this.codeLoading = true;
      this.$FN.get("auth/code").then(res => {
        this.codeLoading = false;
        if (res) {
          let { img = null, uuid = null, msg = t('individualCenter.networkError') } = res;
          if (img && uuid) {
            this.skeletonLoading = false;
            this.code = img;
            this.uuid = uuid;
            this.setForm();
          } else {
            this.$message.error(msg);
            // this.getCodeImg();
          }
        }
      })
    },
    setForm() {
      this.form = {
        username: {
          label: t('login.account'),
          placeholder: t('login.usernamePlaceholder'),
          prefixIcon: "icon-pes_icon_line_yonghuming",
          clearable: true,
          rules: [{ required: true, message: t('login.usernameRequired'), trigger: 'blur' }],
        },
        password: {
          label: t('login.password'),
          type: "password",
          placeholder: t('login.passwordPlaceholder'),
          allowClear: true,
          showPassword: true,
          prefixIcon: "icon-pes_icon_line_mima",
          clearable: true,
          rules: [{ required: true, message: t('login.passwordRequired'), trigger: 'blur' }],
        },
        code: {
          label: t('login.captcha'),
          render: a => {
            let { getCodeImg } = this;

            return (
              <div class="render_code" v-decorator={['code', { rules: [{ required: true, message: t('login.captchaRequired'), trigger: 'blur' }] }]}>
                <div class="left_input">
                  <a-input placeholder={t('login.captchaPlaceholder')} />
                </div>
                <div class="right_img">
                  <img onClick={getCodeImg} src={`${this.code}`} />
                </div>
              </div>
            )
          }
        }
      };
      this.key = Math.random();
    }
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>
